import request from '@/utils/request'

let Info_typeApi = {

  /*同城服务分类列表*/
  list(data) {
    return request._post('/shop/plus.info_type.Index/index', data);
},
/*添加同城服务分类*/
add(data) {
    return request._post('/shop/plus.info_type.Index/add', data);
},
/*修改同城服务分类*/
edit(data) {
    return request._post('/shop/plus.info_type.Index/edit', data);
},
/*删除同城服务分类*/
del(data) {
    return request._post('/shop/plus.info_type.Index/del', data);
},
/*同城服务分类详情*/
detail(data) {
  return request._post('/shop/plus.info_type.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.info_type.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.info_type.Setting/getSetting', data, errorback);
    },
}
export default Info_typeApi;



// WEBPACK FOOTER //
// ./src/api/info_type.js